import script from "./NoticiaDetailView.vue?vue&type=script&setup=true&lang=js"
export * from "./NoticiaDetailView.vue?vue&type=script&setup=true&lang=js"

import "./NoticiaDetailView.vue?vue&type=style&index=0&id=d9705b68&scoped=true&lang=css"
import "./NoticiaDetailView.vue?vue&type=style&index=1&id=d9705b68&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d9705b68"]])

export default __exports__